export default __webpack_public_path__ + "static/hero-bg-b3f1d02ddb0729fd8a909ea7142ae4cb.png";